import axios from "../../axiosInstance";
import type { BadgeWithHierarchy } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const fetchBadgeById = async (id: string): Promise<BadgeWithHierarchy> => {
  const response = await axios.get<BadgeWithHierarchy>(`/api/badges/${id}`);
  return response.data;
};

export default fetchBadgeById;
